import ProductPosts from "./ProductPosts";

import "./ProductPosts.scss";

export * from "./ProductPosts.types";

export { ProductPosts };
